<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone esquerda"><a @click="this.$router.back()" style="cursor: pointer;"
                    class="icone-voltar m-d"></a></div>
            <h2>{{ protocolo.tipo_nome }} - {{ protocolo.codigo }}</h2>
        </div>
    </div>
    <div class="container margem" v-if="protocolo.codigo">
        <div class="abas">
            <a :class="{ 'ativo': aba == 1 }" @click="aba = 1">Planejamento</a>
            <a :class="{ 'ativo': aba == 2 }" @click="aba = 2">Gestão de Acesso</a>
            <a :class="{ 'ativo': aba == 3, 'disabled': (protocolo.tipo_id == 1 && !funcionalidades.includes(198)) }"
                @click="funcionalidades.includes(198) || protocolo.tipo_id != 1 ? aba = 3 : null">
                Registro de Alterações</a>
        </div>
        <ProtocoloComponent :propProtocolo="protocolo" :destaque-tarefa-id="$route.query.destaque_tarefa_id"
            v-if="aba == 1" />
        <ParticipantesProtocolo :protocolo="protocolo" v-if="aba == 2" @salvar="salvarParticipantes" />
        <AlteracoesProtocolo :protocolo="protocolo" v-if="aba == 3" />
    </div>
    <ChamarDemanda :propSigla="sigla" :propId="protocolo.id" />
</template>

<script>
import { ChamarDemanda } from "roboflex-thalamus-componentes-vue3-lib";
import ParticipantesProtocolo from "@/components/Protocolo/ParticipantesProtocolo.vue";
import ProtocoloComponent from "@/components/Protocolo/ProtocoloComponent.vue";
import serviceProtocolo from "@/services/serviceProtocolo";
import AlteracoesProtocolo from "@/components/Protocolo/AlteracoesProtocolo.vue";
import { getPermissao } from "@/services/permissao-service";
export default {
    props: {
        idProtocolo: {
            required: true
        },
    },

    components: {
        ProtocoloComponent,
        ParticipantesProtocolo,
        ChamarDemanda,
        AlteracoesProtocolo
    },

    data() {
        return {
            aba: 1,
            protocolo: {},
            funcionalidades: [],
        }
    },

    async mounted() {
        this.getProtocolo()
        this.funcionalidades = await getPermissao()
    },

    computed: {
        sigla() {
            switch (this.protocolo.tipo_nome) {
                case 'TNC':
                    return 'TNC'
                case 'RAP':
                    return 'RAP'
                case 'Ordem de Serviço':
                    return 'OS'
                case 'Plano de Ação':
                    return 'PLA'
                case 'Plano de Alteração de Produto':
                    return 'PAP'
                default:
                    return ''
            }
        }
    },

    methods: {
        async getProtocolo() {
            var response = await serviceProtocolo.getProtocoloById(this.idProtocolo);
            this.protocolo = response[0]
            this.protocolo.id = this.idProtocolo;
            this.protocolo.tarefas = this.protocolo.tarefas.map(i => ({
                ...i,
                anexos: i.anexos || [],
                dtInicio: this.formatarData(i.dtInicio),
                dtFim: this.formatarData(i.dtFim),
                dtInicioReal: this.formatarData(i.dtInicioReal),
                dtFimReal: this.formatarData(i.dtFimReal),
            }))
        },
        formatarData(data) {
            if (!data) {
                return null
            }
            return data.split(' ')[0]
        }
    }
}
</script>
<style scoped></style>